<div class="w-full h-full p-1">
  <p-scrollPanel [style]="{ width: '100%', height: '100%' }">
    <app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">
      @if (stressOptionsForm) {
      <form [formGroup]="stressOptionsForm">

        <div class="w-full mb-2">
          <label for="maximumGridSpacing">Vertical Grid Spacing</label>
          <app-validated-number-input
            [id]="'maximumGridSpacing'"
            [control]="maximumGridSpacingControl"
            [value]="maximumGridSpacingControl.value"
            [validation]="gridSpacingValidation"
            [unit]="verticalGridUnit">
          </app-validated-number-input>
        </div>

        <label for="maximumGridSpacing">API TR 5C3 Collapse Formula</label>
        <p-select id="apiCollapseType" formControlName="apiCollapseType" [options]="apiCollapse" appendTo="body"
          class="w-full mb-2">
        </p-select>

        <div class="mb-2">
          <p-fieldset legend="Buckling Parameters">
            <label for="helicalFactorType">Critical Ratio for Transition to Helical Buckling:</label>
            <div class="flex flex-nowrap items-start pb-3">
              <div class="flex-1 min-w-0">
                <p-select id="helicalFactorType" formControlName="helicalFactorType" [options]="helicalFactorTypes"
                  appendTo="body" class="w-full"></p-select>
              </div>
              <div class="flex-1 min-w-0">
                <app-validated-number-input
                  [id]="'helicalBucklingFactor'"
                  [control]="helicalBucklingFactorControl"
                  [value]="helicalBucklingFactorControl.value"
                  [validation]="helicalBucklingFactorValidation"
                  [readonly]="stressOptionsForm.controls.helicalBucklingFactor.disabled"
                  [unitPrecisionOverrides]="{'': 3}"
                ></app-validated-number-input>
              </div>
            </div>
            <p-checkbox size="small" binary="true" inputId="useHeKyllingstad" formControlName="useHeKyllingstad"></p-checkbox>
            <label class="ml-2" for="useHeKyllingstad"> He-Kyllingstad Buckling Dogleg Correlation</label>
          </p-fieldset>
        </div>

        <p-fieldset>
          <!-- Basic Friction Factor Section -->
          <ng-template pTemplate="header">
            <div class="flex items-center">
              <input (change)="onBasicFrictionSelect($event)" id="includeFriction" type="checkbox" binary="true" formControlName="useBasicFriction">
              <label class="pl-2" for="includeFriction">
                Include Friction
                <i pTooltip="Friction may be included in the tubular stress design. Wellbore friction loads are modelled for the running/installation scenario and locked into the analysis. After installation (landing in hanger, setting of cement and/or packers), frictional contact is perturbed so that frictional loads migrate along the string. In general, this provides for a worst-case analysis." class="pt-1 pl-1 pi pi-info-circle cursor-help relative z-[2]"></i>
              </label>
            </div>
          </ng-template>

          <div class="flex flex-col mb-2" formGroupName="basicFriction">
            <label for="frictionFactor">Friction Factor</label>
            <p-inputnumber id="basicFriction.frictionFactor" class="w-full"
              formControlName="frictionFactor" [minFractionDigits]="1">
            </p-inputnumber>
          </div>

          <!-- Damping Type Section -->
          <!-- <p-fieldset legend="Damping Type">
          <div class="flex">
            <input type="radio" binary="true" formControlName="dampingType"
              [checked]="stressOptionsForm.controls.dampingType.value === 'artificialDamping'"
              (click)="dampingTypeChange('artificialDamping')">
            <label class="ml-2">Artificial Damping</label>
          </div>
  
          <div class="flex">
            <input type="radio" binary="true" formControlName="dampingType"
            [checked]="stressOptionsForm.controls.dampingType.value === 'fluidDamping'"
            (click)="dampingTypeChange('fluidDamping')">
            <label class="ml-2">Fluid Damping</label>
          </div>
        </p-fieldset> -->
        </p-fieldset>
      </form>
      }
    </app-tool-loader>
  </p-scrollPanel>
</div>